/** Traductions modal import rapide Excel (FR / AR) — catalogue only */
export const fastImportModalFr = {
  title: 'Import Rapide Excel',
  selectFile: 'Sélectionner un fichier Excel',
  dropHint: 'Glissez-déposez un fichier Excel ici ou cliquez pour sélectionner',
  chooseFile: 'Choisir fichier',
  downloadTemplate: 'Télécharger le modèle Excel',
  importing: 'Importation en cours...',
  productsUnit: 'produits',
  previewTitle: 'Aperçu des données',
  moreRows: 'Et {{count}} autres lignes...',
  cancel: 'Annuler',
  importingShort: 'Importation...',
  importProducts: 'Importer les produits',
  invalidFile: 'Veuillez sélectionner un fichier Excel valide (.xlsx ou .xls)',
  parseError: 'Erreur lors de l\'analyse du fichier',
  fileEmpty: 'Le fichier Excel est vide',
  fileReadError: 'Erreur lors de la lecture du fichier',
  importSuccess: '{{count}} produits importés avec succès',
  errorsEncountered: '{{count}} erreurs rencontrées',
  importError: 'Erreur lors de l\'importation',
  rowNameRequired: 'Nom du produit requis'
};

export const fastImportModalAr = {
  title: 'استيراد سريع من Excel',
  selectFile: 'اختر ملف Excel',
  dropHint: 'اسحب وأفلت ملف Excel هنا أو انقر للاختيار',
  chooseFile: 'اختيار ملف',
  downloadTemplate: 'تحميل قالب Excel',
  importing: 'جاري الاستيراد...',
  productsUnit: 'منتج',
  previewTitle: 'معاينة البيانات',
  moreRows: 'و {{count}} صفوف أخرى...',
  cancel: 'إلغاء',
  importingShort: 'جاري الاستيراد...',
  importProducts: 'استيراد المنتجات',
  invalidFile: 'يرجى اختيار ملف Excel صحيح (.xlsx أو .xls)',
  parseError: 'خطأ في تحليل الملف',
  fileEmpty: 'ملف Excel فارغ',
  fileReadError: 'خطأ في قراءة الملف',
  importSuccess: 'تم استيراد {{count}} منتج بنجاح',
  errorsEncountered: '{{count}} أخطاء',
  importError: 'خطأ أثناء الاستيراد',
  rowNameRequired: 'اسم المنتج مطلوب'
};
